import React, {Component} from 'react';

class SimpleChart extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.loadHistory = this.loadHistory.bind(this);
    }

    componentDidMount() {
        this.loadHistory(this.props.coinData);
    }

    componentDidUpdate() {
        this.loadHistory(this.props.coinData);
    }

    loadHistory(historyData) {
        if (!this.chart || !historyData) {
            return;
        }

        let canvas = this.chart;
        const ctx = this.chart.getContext('2d');
        let history = historyData.history || [];
        if (!history || history.length === 0) {
            return;
        }
        let historyCount = historyData.historyCount;
        let width = 200;
        let height = 40;
        canvas.width = width;
        canvas.height = height + 4;

        let chartPadding = 1;
        let xWidth = width / historyCount;

        // Retina fix so we don't have blurry charts.
        if (window.devicePixelRatio > 1) {
            let canvasWidth = canvas.width;
            let canvasHeight = canvas.height;

            canvas.width = canvasWidth * window.devicePixelRatio;
            canvas.height = canvasHeight * window.devicePixelRatio;
            canvas.style.width = canvasWidth + 'px';
            canvas.style.height = canvasHeight + 'px';

            ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        }

        let gradient = ctx.createLinearGradient(height / 2, 0, width, height / 2);
        gradient.addColorStop(0, "#4d9ff5");
        gradient.addColorStop(1, "#4990e2");

        ctx.clearRect(0, 0, this.chart.width, this.chart.height);
        ctx.lineJoin = "round";
        ctx.lineWidth = 2;
        ctx.strokeStyle = gradient;
        ctx.beginPath();

        let previousHistory;
        for (let i = 0; i < history.length; i++) {
            let historyObj = history[i];
            let normalizedPrice = historyObj[1];
            if (previousHistory) {
                ctx.lineTo((i * xWidth) + chartPadding, (height * (1-normalizedPrice)) + chartPadding);
            } else {
                ctx.moveTo(chartPadding, (height * (1-normalizedPrice)) + chartPadding);
            }

            previousHistory = historyObj;
        }
        ctx.stroke();
    }

    render() {
        this.loadHistory(this.props.coinData);

        return (
            <canvas
                width="200"
                height="44"
                className="cg-simple-chart"
                ref={(chart) => {
                    this.chart = chart;
                }}
            />
        );
    }
}

export default SimpleChart;



// WEBPACK FOOTER //
// ./src/SimpleChart.js